import React, { useRef } from 'react';
import Layout from '../Layout';
import { Image, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './css/service.css';

const Careers = () => {
    return (
        <Layout>


            <section className='abt-container'>
                <div className='career-header'>
                    <Image src="/careerOne.png" className="d-inline-block  img-fluid" alt="inovative" />

                    <div className='header-content'>
                        <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Careers</h1>
                        <p className='wow animate__animated animate__fadeInUp' data-wow-duration='2s'>Your success is our success</p>
                    </div>

                </div>
            </section>


            <section className='child-container serv'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Divs Global is an equal opportunity Employer.<br /> We do not discriminate against
                    applicants based on race, colour, ethnicity, origin, religion, age, or class</h1>
            </section>


            <section className='info-container'>
                <div className="servflex">
                    <div className="">
                        <div className="serv-line" />
                    </div>

                    <div className=''>
                        <p className='servParagText wow animate__animated animate__fadeInDown' data-wow-duration='1.5s'>We have a place for you, no matter the stage of your career. While we pride ourselves on a tradition of internal promotions and transfers, we also place a high value on expertise from outside our company; fresh talent means fresh ideas. Create your own career path by working in one or more of our diverse business areas.</p>
                    </div>
                </div>
            </section>

            <section className='info-container'>
                <div className='sectionTwo mt-4'>
                    <Image src="/career.png" className="d-inline-block  img-fluid wow animate__animated animate__fadeInUp" data-wow-duration="1.5s" alt="inovative" />
                </div>
            </section>

            <section className='sectionThree'>
                <div className='child-container'>
                    <div className='sectionInner'>
                        <div className='secThreeTwo'>
                            <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Create your own career path by working in one or more of our diverse business areas.</h1>
                        </div>
                    </div>


                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='wow animate__animated animate__fadeInUp mt-4' data-wow-duration='1s'>
                                <h4 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>You will be challenged every day.</h4>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Your drive for excellence should be matched by a strong commitment to reach your goals safely and ethically.</p>
                            </div>

                        </div>

                        <div className='col-lg-6'>
                            <div className='wow animate__animated animate__fadeInUp mt-4' data-wow-duration='1s'>
                                <h4 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Your efforts are rewarded.</h4>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Join the team that offers generous employee benefits, including tuition assistance, wellness programs, competitive pay, and incentives.</p>
                            </div>
                        </div>


                        <div className='col-lg-6'>
                            <div className='wow animate__animated animate__fadeInUp mt-4' data-wow-duration='1s'>
                                <h4 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>You’re part of the family.</h4>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We encourage team-building by promoting fun, outings, and get-togethers.</p>
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <div className='wow animate__animated animate__fadeInUp mt-4' data-wow-duration='1s'>
                                <h4 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>We are in it to win it.</h4>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Our commitment to support energy independence sustainability, and creating more jobs in Nigeria!</p>
                            </div>
                        </div>



                    </div>


                </div>
            </section>

            <section className='child-container'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>If you have what it takes to be part of the winning team,<br/> please send your cv to <a href="mailto:careers@divsglobal.com" >careers@divsglobal.com</a>.</h1>
            </section>


        </Layout>
    );
};

export default Careers;